/*
 * Shows a loading state (spinner + disabled) on a form's submit button when the
 * form is submitted. Intended for native, full-page-reload form submits (e.g.
 * Shopify `{% form 'customer' %}` newsletter signups): the spinner stays until
 * the page reloads, giving feedback during the network + reCAPTCHA round-trip.
 *
 * Mark the submit button with `data-form-loading-button` and give it a
 * `[data-loading="true"]` spinner in CSS. Used by both the welcome popup and the
 * about-us newsletter block; binding is global and idempotent so loading this
 * asset more than once on a page is safe.
 */
(function () {
  // `window` has no index signature under checkJs, so cast to reach our flag.
  var w = /** @type {any} */ (window);
  if (w.__offsideFormLoadingBound) return;
  w.__offsideFormLoadingBound = true;

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Narrow to HTMLButtonElement (a const, so it stays narrowed inside the
    // rAF closure) — this types .dataset/.disabled and rules out null.
    const button = form.querySelector("[data-form-loading-button]");
    if (!(button instanceof HTMLButtonElement)) return;

    // In the theme editor, block the native submit so it can't reload the
    // preview iframe — and skip the spinner so it never sticks.
    if (w.Shopify && w.Shopify.designMode) {
      event.preventDefault();
      return;
    }

    // The submit event only fires once the browser's built-in validation has
    // passed, so it's safe to enter the loading state here.
    button.dataset.loading = "true";
    button.setAttribute("aria-busy", "true");

    // Defer disabling by a frame so the in-flight native submission isn't
    // interfered with, while still preventing a double submit.
    window.requestAnimationFrame(function () {
      button.disabled = true;
    });
  });
})();
